/**
 * Footer Component
 * Professional footer with company information
 */
import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="bg-white rounded-lg p-2 flex items-center justify-center shadow-sm border border-gray-200">
                <img 
                  src="/Ignite_Logo.png" 
                  alt="IDT IGNITE QUARKS" 
                  className="h-6 w-auto max-w-[120px] object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              <h3 className="text-lg font-bold">IDT IGNITE QUARKS</h3>
            </div>
            <p className="text-gray-400 text-sm">
              Innovation Token Distribution Platform
            </p>
            <p className="text-gray-400 text-sm mt-2">
              Empower your team to innovate
            </p>
          </div>
          
          {/* Support */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">Support</h4>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">
                <span className="font-medium text-white">Email:</span> support@hidglobal.com
              </li>
              <li className="text-gray-400 text-sm">
                <span className="font-medium text-white">Help:</span> Available 24/7
              </li>
              <li className="text-gray-400 text-sm">
                <span className="font-medium text-white">Version:</span> 1.0.0
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} HID Global. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#terms" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms of Service
              </a>
              <a href="#help" className="text-gray-400 hover:text-white text-sm transition-colors">
                Help Center
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

